class QuickShopLoader extends HTMLButtonElement {
  handle = this.getAttribute('handle') || null;

  connectedCallback() {
    if (!this.handle) return;
    this.addEventListener('click', () => this.loadQuickShopModal());
  }

  async loadQuickShopModal() {
    this.loading();
    try {
      const response = await fetch(`/products/${this.handle}?section_id=quick-shop`);
      if (!response.ok) throw new Error(response.statusText);
      const text = await response.text();
      const html = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('.shopify-section').innerHTML;
      document.body.insertAdjacentHTML('beforeend', html);
      document.getElementById(`quick-shop-${this.handle}`)?.open();
    } catch (error) {
      console.error(error);
    } finally {
      this.loading(false);
    }
  }

  /**
   * loading
   * @param {Boolean} state
   */
  loading(state = true) {
    state ? this.classList.add('loading') : this.classList.remove('loading');
    state ? this.setAttribute('disabled', true) : this.removeAttribute('disabled');
  }
}

if (!customElements.get('quick-shop-loader')) {
  customElements.define('quick-shop-loader', QuickShopLoader, { extends: 'button' });
}

class QuickShopLightbox extends HTMLElement {
  connectedCallback() {
    this.closeClickOutside = (event) => {
      if (!this.querySelector('[data-quick-shop-lightbox="content"]').contains(event.target)) {
        this.close();
      }
    };

    this.closeOnEscape = (event) => {
      if (event.key === 'Escape') {
        this.close();
      }
    };

    this.querySelectorAll('[data-quick-shop-lightbox="close"]')?.forEach((close) => {
      close.addEventListener('click', () => this.close());
    });

    this.querySelector('[data-quick-shop-lightbox="backdrop"]')?.addEventListener('click', () => {
      this.close();
    });
  }

  close() {
    this.classList.remove('open');
    this.setAttribute('aria-hidden', true);
    document.removeEventListener('click', this.closeClickOutside);
    document.removeEventListener('keydown', this.closeOnEscape);

    this.remove();
  }

  open() {
    this.classList.add('open');
    this.setAttribute('aria-hidden', false);
    document.addEventListener('click', (event) => this.closeClickOutside(event));
    document.addEventListener('keydown', (event) => this.closeOnEscape(event));
  }
}

if (!customElements.get('quick-shop-lightbox')) {
  customElements.define('quick-shop-lightbox', QuickShopLightbox);
}

class QuickShop extends HTMLElement {
  productForm = this.querySelector('product-form') || null;
  quickShopLightbox = this.closest('quick-shop-lightbox') || null;
  label = this.querySelector('[data-product-switch="title"]');

  connectedCallback() {
    this.productForm.addEventListener('cart-updated', () => {
      this.quickShopLightbox?.close();
    });

    this.originalTitle = this.label.textContent || '';
    this.buttons = this.querySelectorAll('[data-switch-product]');
    this.buttons.forEach((button) => {
      button.addEventListener('click', (event) => this.switchProduct(event));
      button.addEventListener('mouseover', (event) => {
        this.label.textContent = event.currentTarget.getAttribute('title');
      });
      button.addEventListener('mouseout', () => {
        this.label.textContent = this.originalTitle;
      });
    });
  }

  async switchProduct(event) {
    const url = event.currentTarget.dataset.switchProduct;

    if (!url) return;

    try {
      this.loading();
      const response = await fetch(`${url}?section_id=quick-shop`);
      if (!response.ok) throw new Error(response.statusText);
      const text = await response.text();
      const html = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('[data-quick-shop-lightbox="content"]').innerHTML;
      this.insertAdjacentHTML('afterend', html);
      this.remove();
    } catch (error) {
      this.loading(false);
    }
  }

  loading(state = true) {
    state ? this.setAttribute('aria-busy', true) : this.removeAttribute('aria-busy');
  }
}

if (!customElements.get('quick-shop')) {
  customElements.define('quick-shop', QuickShop);
}
